import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { FC, ReactNode } from 'react';
import { Typography } from '@/components/shared/Typography';
import css from './style.module.scss';
interface Props {
  services: string[];
  industries: string[];
  selectedServices: string[];
  selectedIndustries: string[];
  onToggleFilter: (category: 'service' | 'industry', value: string) => void;
  onClearFilters: (category: 'service' | 'industry') => void;
  children?: ReactNode;
}
const Filters: FC<Props> = t0 => {
  const $ = _c(2);
  let t1;
  if ($[0] !== t0) {
    const {
      children,
      ...props
    } = t0;
    const {
      services,
      industries,
      selectedServices,
      selectedIndustries,
      onToggleFilter,
      onClearFilters
    } = props;
    const renderFiltersGroup = t2 => {
      const {
        title,
        category,
        filterGroup,
        selectedFilterGroup
      } = t2;
      return <div className={css.filtersGroup}><h2 className={css.groupTitle}>{title}</h2>{selectedFilterGroup.length ? <button className={css.filterButton} onClick={() => onClearFilters(category)}><Typography variant="body-m" tag="span">Clear all</Typography></button> : null}{filterGroup.map(filter => <button key={filter} className={clsx(css.filterButton, selectedFilterGroup.includes(filter) ? css.active : "")} onClick={() => onToggleFilter(category, filter)}><Typography variant="body-m" tag="span">{filter}</Typography><svg className={css.filterClearIcon} xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M1.75781 1.75781L10.2431 10.2431" stroke="currentColor" /><path d="M10.2422 1.75781L1.75691 10.2431" stroke="currentColor" /></svg></button>)}</div>;
    };
    t1 = <div className={css.wrapper}>{renderFiltersGroup({
        title: "Services:",
        category: "service",
        filterGroup: services,
        selectedFilterGroup: selectedServices
      })}{renderFiltersGroup({
        title: "Industries:",
        category: "industry",
        filterGroup: industries,
        selectedFilterGroup: selectedIndustries
      })}{children}</div>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default Filters;